/* eslint-disable react-hooks/rules-of-hooks */
import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import REACT_APP from "../../environment";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "axios";
import { toast } from "react-toastify";
import Spinner from "../Company/Spinner";

export default function deleteType({
  id,
  setIsWaiting,
  handleMenuClose,
  getTypes,
}) {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [wait, setwait] = React.useState(false);
  const [waittext, setwaittext] = React.useState("");
  const [valueSpinner, setValueSpinner] = React.useState(0);

  const blocked = async () => {
    try {
      setIsWaiting(true);
      setwait(true);
      setwaittext("in progress");
      setValueSpinner(100);
      await axios.delete(`${REACT_APP.URL}/api/hdp/tts/adm/hotel/types/${id}`, {
        headers: {
          Authorization: sessionStorage.getItem("token"),
          "client-id": REACT_APP.CLIENTID,
          "client-secret": REACT_APP.SECRET,
        },
      });
      setwaittext("table is being updated");
      await getTypes().catch((e) => console.log(e));
      setIsWaiting(false);
      handleClose();
      toast.success("Success", { autoClose: 2000 });
      handleMenuClose();
    } catch (err) {
      console.log(err);
      handleClose();
      setIsWaiting(false);
      toast.error("Something went wrong");
    }
  };

  return (
    <div>
      <Button onClick={handleClickOpen}>delete</Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Delete this type</DialogTitle>
        {wait ? (
          <Spinner value={valueSpinner} />
        ) : (
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Do you want to delete this hotel type?
            </DialogContentText>
          </DialogContent>
        )}
        <DialogActions>
          {wait ? (
            <div
              style={{
                width: "100%",
                color: "#777",
                fontSize: "0.8em",
                padding: "0 20px",
              }}
            >
              {waittext}
            </div>
          ) : (
            <>
              <Button onClick={handleClose}>Cancel</Button>
              <Button onClick={blocked}>Delete</Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
